import { render, staticRenderFns } from "./FileCount.vue?vue&type=template&id=5182b9b8&scoped=true&"
import script from "./FileCount.vue?vue&type=script&lang=js&"
export * from "./FileCount.vue?vue&type=script&lang=js&"
import style0 from "./FileCount.vue?vue&type=style&index=0&id=5182b9b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182b9b8",
  null
  
)

export default component.exports